<template>
  <div class="show-container">
    <div :id="id" style="height: 100%;" v-if="hasData"></div>
    <show-no-data v-else></show-no-data>
  </div>
</template>

<script>
  import eCharts from 'echarts'
  import 'echarts/theme/macarons'
  import analyseUtil from '../analyse-util'
  import ShowNoData from '../show-no-data'
  import {addResizeListener, removeResizeListener} from 'element-ui/src/utils/resize-event'

  export default {
    components: {
      ShowNoData
    },
    props: {
      data: {
        type: 'Object'
      }
    },
    name: 'funnel-config',
    typeCode: '4',
    data() {
      return {
        id: analyseUtil.randomId(),
        myChart: {},
        options: {
          tooltip: {
            trigger: 'item',
            formatter: '{b} {c}({d}%)'
          },
          grid: {
            left: 0,
            right: 0
          },
          legend: {
            orient: 'vertical',
            x: 'right',
            y: 'bottom',
            data: null
          },
          series: []
        }
      }
    },
    mounted() {
      if (this.hasData) {
        this.loadChart()
        addResizeListener(this.$el, this.resizeListener)
      }
    },
    beforeDestroy() {
      if (this.hasData) {
        removeResizeListener(this.$el, this.resizeListener)
      }
    },
    computed: {
      hasNoZero: function () {
        let hasNoZero = false
        for (let i = 0; i < this.data.data.length; i++) {
          hasNoZero = this.data.data[i].value ? this.data.data[i].value !== 0 : false
          if (hasNoZero) {
            break
          }
        }
        return hasNoZero
      },
      hasData: function () {
        return this.data.data !== null && this.data.data.length > 1 && this.hasNoZero
      },
      legendData: function () {
        let data = []
        for (let i = 0; i < this.data.data.length; i++) {
          data.push(this.data.data[i].name)
        }
        return data
      },
      basicSeries: function () {
        let data = []
        let maxValue = this.data.data[0].value
        let divideValue = maxValue / this.data.data.length
        for (let i = 0; i < this.data.data.length; i++) {
          data.push({
            name: this.data.data[i].name + '预期',
            value: maxValue - i * divideValue,
            itemStyle: {color: analyseUtil.COLORS[i]}
          })
        }
        return {
          type: 'funnel',
          top: 20,
          bottom: 0,
          left: 20,
          right: 20,
          label: {
            show: false
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              opacity: 0.8
            }
          },
          data: data
        }
      },
      seriesData: function () {
        return {
          type: 'funnel',
          top: 20,
          bottom: 0,
          left: 20,
          right: 20,
          sort: 'descending',
          itemStyle: {
            normal: {
              opacity: 0.5,
              borderColor: '#fff',
              borderWidth: 2
            }
          },
          label: {
            show: true,
            position: 'inside'
          },
          data: this.data.data
        }
      }
    },
    methods: {
      resizeListener: function () {
        this.$nextTick(() => {
          if (this.myChart !== null) {
            this.myChart.resize()
          }
        })
      },
      loadChart: function () {
        this.myChart = eCharts.init(document.getElementById(this.id), 'shine')
        this.options.legend.data = this.legendData
        for (let i = 0; i < this.data.data.length; i++) {
          this.data.data[i].itemStyle = {color: analyseUtil.COLORS[i]}
        }
        this.options.series.push(this.basicSeries)
        this.options.series.push(this.seriesData)
        this.myChart.setOption(this.options)
        this.myChart.hideLoading()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/funnel-config.vue